module.exports = __webpack_public_path__ + "img/headset3.7f6daf59.jpg";